var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"xTable",attrs:{"resizable":"","column-config":{ minWidth: '80px' },"data":_vm.tableData,"toolbar-config":_vm.tableToolbar,"size":"mini","mouse-config":{ area: true, extension: true },"highlight-hover-row":"","highlight-current-row":"","height":_vm.tableHeight,"columns":_vm.gridColumns,"menu-config":{
      body: { options: _vm.bodyMenus },
      visibleMethod: _vm.visibleMethod,
    },"edit-rules":_vm.validRules,"edit-config":{
      trigger: 'dblclick',
      mode: 'cell',
      activeMethod: _vm.activeMethod,
    },"keyboard-config":{
      isArrow: true,
      isEnter: true,
      isTab: true,
      enterToTab: true,
      isClip: true,
      isEdit: true,
      editMethod: _vm.editMethod,
    }},on:{"toolbar-button-click":_vm.toolbarButtonClickEvent,"menu-click":_vm.contextMenuClickEvent,"cell-menu":_vm.cellContextMenuEvent}}),_c('PickPosition',{ref:"PickPosition",attrs:{"positionOptions":_vm.positionOptions,"visiblePosition":_vm.selectVisiblePositionArr,"isMultiple":false},on:{"sureBackPosition":_vm.sureBackPosition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }